import { NavLink } from 'react-router-dom'
import { FileText, Lightbulb, Settings, Zap } from 'lucide-react'
import { cn } from '@/lib/utils'

const navigation = [
  { name: 'Articoli', href: '/articles', icon: FileText },
  { name: 'Proposte', href: '/proposals', icon: Lightbulb },
  { name: 'Impostazioni', href: '/settings', icon: Settings },
]

export function Sidebar() {
  return (
    <aside className="fixed inset-y-0 left-0 z-40 w-64 bg-white border-r border-gray-200 hidden lg:block">
      {/* Logo */}
      <div className="flex items-center gap-2 h-16 px-6 border-b border-gray-200">
        <div className="flex items-center justify-center w-8 h-8 bg-primary-600 rounded-lg">
          <Zap className="w-5 h-5 text-white" />
        </div>
        <span className="font-semibold text-gray-900">WP Autopilot</span>
      </div>

      {/* Navigation */}
      <nav className="p-4 space-y-1">
        {navigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              )
            }
          >
            <item.icon className="w-5 h-5" />
            {item.name}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
        <div className="text-xs text-gray-500">
          <p>Dokicasa.it</p>
          <p className="mt-1">v0.1.0</p>
        </div>
      </div>
    </aside>
  )
}
